import React, { useEffect } from 'react';
import { Typography, Box, Stack, Button, Grid, Select, MenuItem } from '@mui/material';
import VariationPanel from './VariationPanel';
import MicroContentSummaryPanel from './MicroContentDetails';

export default function MicroContentEditPanel({ microContent, onSelectMicroContent }) {
    const [selectedVariation, setSelectedVariation] = React.useState({});

    const onSelectVariation = (variation) => {
        console.log('select variation', {variation});
        setSelectedVariation(variation);
    }

    return (
        <Stack direction="row">
            <Grid container spacing={2} flex="1">
                <Grid item xs={4}>
                    <MicroContentSummaryPanel microContent={microContent} />
                </Grid>
                <Grid item xs={8}>
                    <Stack direction="column" display="flex" justifyItems="center">
                        <VariationPicker
                            microContent={microContent}
                            onVariationSelected={onSelectVariation}
                            onSelectMicroContent={onSelectMicroContent}
                        />
                        <hr />
                        {!selectedVariation && (<Typography>No Variation Selected...</Typography>)}
                        {!!selectedVariation && (<VariationPanel microContent={microContent} variation={selectedVariation} />)}
                    </Stack>
                </Grid>
            </Grid>
        </Stack>
    );
}

function VariationPicker({ microContent, onVariationSelected, onSelectMicroContent }) {
    const [selectedCode, setSelectedCode] = React.useState('GLOBAL_ANY');

    useEffect(() => {
        const variation = microContent.contentList?.find((v) => makeVariationCode(v) === selectedCode);
        variation && onVariationSelected(variation);
    }, [selectedCode, microContent.contentList, microContent.content?.variations, onVariationSelected]);

    useEffect(() => {
        var items = microContent.contentList
                    ?.sort((v1, v2) => {
                        return makeVariationCode(v1) < makeVariationCode(v2) ? -1 : 1;
                    });
        if(items) setSelectedCode(makeVariationCode(items[0]))
    }, [microContent.contentList]);

    function assignVariation() {
        console.log('assign variation');
        const variation = microContent.contentList?.find((v) => makeVariationCode(v) === selectedCode);
        onSelectMicroContent(microContent, variation);
    }

    if (!microContent.contentList) {
        return <Typography>No variations defined for this Content. Please fix this in AEX.</Typography>;
    }

    function makeVariationCode(variation) {
        return (variation.locations || 'GLOBAL') + '_' + (variation.participants || 'ANY');
    }
    return (
        <Stack direction="row" display="flex" alignContent="space-between" flex="1">
            <Typography sx={{ mr: 2, pt: 1, pb: 0 }} variant="h6" display="inline">
                Variations{' '}
            </Typography>
            <Select
                size="small"
                style={{ backgroundColor: 'white', flex: 1 }}
                value={selectedCode}
                onChange={(e) => setSelectedCode(e.target.value)}
            >
                {microContent.contentList
                    ?.sort((v1, v2) => {
                        return makeVariationCode(v1) < makeVariationCode(v2) ? -1 : 1;
                    })
                    .map((v) => (
                        <MenuItem key={makeVariationCode(v)} value={makeVariationCode(v)}>
                            {makeVariationCode(v)} : {[v.locations, v.participants, v.extraCriteria].filter((x) => x).join(' / ')}
                        </MenuItem>
                    ))}
            </Select>
            <Box flex="0 1" ml={1}>
                <Button
                    flex={1}
                    sx={{ whiteSpace: 'nowrap' }}
                    variant="contained"
                    color="primary"
                    onClick={assignVariation}
                >
                    Assign This Content
                </Button>
            </Box>
        </Stack>
    );
}
